import { api } from "./api";

export const checkoutListPayment = async (webToken: string) => {
  const { data } = await api.get(
    "finance/checkout/payment-by-webtoken/" + webToken,
  );
  return data;
};

export const checkoutCreditCard = async (body: any) => {
  const { data } = await api.post("finance/checkout", body);
  return data;
};

export const renewPix = async (body: any): Promise<any> => {
  const { data } = await api.post("/finance/checkout/renew-pix", body);
  return data;
};

export const canceledInvoice = async (id: number): Promise<any> => {
  const { data } = await api.delete("/finance/checkout/canceled-invoice/" + id);
  return data;
};

export const renewPixPayment = async (webToken: string) => {
  const { data } = await api.post("/finance/checkout/renew-pix-by-token", {
    webToken,
  });
  return data;
};
